// extracted by mini-css-extract-plugin
module.exports = {"max-width-large":"1024px","badge":"DiscoverLink__badge"};